// request.js
import axios from "axios";
import { getToken } from "./auth"; // Adjust the path as necessary

// Create an Axios instance
const service = axios.create({
  baseURL: import.meta.env.VITE_APP_BASE_API_V1 + "/api/v1",
  timeout: 20000,
  headers: {
    "Content-Type": "application/json;charset=utf-8",
  },
});

// Request interceptor to add the token
service.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// // Response interceptor to handle responses and errors
// service.interceptors.response.use(
//   (response) => response.data,
//   (error) => {
//     console.error(
//       "API Request failed:",
//       error.response?.data?.message || error.message
//     );
//     return Promise.reject(error);
//   }
// Response interceptor to handle responses and errors
service.interceptors.response.use(
  (response) => response.data,
  (error) => {
    // Handle other types of errors (e.g., API errors)
    console.error(
      "API Request failed:",
      error.response?.data?.message || error.message
    );
    return Promise.reject(error);
  }
);
export default service;
